import type { ReactNode } from "react";

import { linkCss } from "./index.styles";

import { Link } from "~/client/components/Link";

interface Props {
  to: string;
  children: ReactNode;
}
export const ListItemLink: React.FC<Props> = ({ to, children }) => {
  return (
    <Link to={to} css={linkCss}>
      {children}
    </Link>
  );
};
